import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "rangoli_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  function addItem(product, quantity = 1) {
    setItems((prev) => {
      const idx = prev.findIndex((x) => x.product_id === product.id);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, {
        product_id: product.id,
        name: product.name,
        price: product.price,
        image: product.images?.[0] || null,
        quantity,
      }];
    });
  }

  function updateQty(product_id, quantity) {
    setItems((prev) =>
      prev.map((it) => it.product_id === product_id ? { ...it, quantity } : it)
        .filter((it) => it.quantity > 0)
    );
  }

  function removeItem(product_id) {
    setItems((prev) => prev.filter((it) => it.product_id !== product_id));
  }

  function clear() { setItems([]); }

  const subtotal = items.reduce((s, it) => s + it.price * it.quantity, 0);
  const count = items.reduce((s, it) => s + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() { return useContext(CartContext); }
